module.exports = __webpack_public_path__ + "static/img/page36.27fbbbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page36.jpg
// module id = xVC3
// module chunks = 0